<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-actions">
				<div className="sf-actions__left">
					<!-- 저장 保存-->
					<sf-button line size="sm" icon="file" color="info" :onClick="() => saveAction('0')" v-if="isButton_(scrId, 'TS') && showSaveBtn">
						{{ getButtonMsg_(scrId, 'TS') }}
					</sf-button>
					<!-- 작성 创建-->
					<sf-button line size="sm" icon="round-check-on" :onClick="() => saveAction('20')" v-if="isButton_(scrId, 'WR') && showRegBtn">
						{{ getButtonMsg_(scrId, 'WR') }}
					</sf-button>
					<!-- 회신 回复-->
					<sf-button line size="sm" icon="round-check-on" :onClick="() => saveAction('30')" v-if="isButton_(scrId, 'RP') && showIspBtn">
						{{ getButtonMsg_(scrId, 'RP') }}
					</sf-button>
					<!-- 검토 审阅-->
					<sf-button line size="sm" icon="round-check-on" :onClick="() => saveAction('40')" v-if="isButton_(scrId, 'IP') && showCsetBtn">
						{{ getButtonMsg_(scrId, 'IP') }}
					</sf-button>
					<!-- 반려 退回-->
					<sf-button line size="sm" icon="circle-close" :onClick="() => saveAction('10')" v-if="isButton_(scrId, 'GV') && showRejectBtn">
						{{ getButtonMsg_(scrId, 'GV') }}
					</sf-button>
					<!-- 삭제 删除-->
					<sf-button line size="sm" icon="trash" color="error" :onClick="deleteAction" v-if="isButton_(scrId, 'CD') && showDeleteBtn">
						{{ getButtonMsg_(scrId, 'CD') }}
					</sf-button>
					<!-- 이메일 전송 -->
					<!-- <sf-button line size="sm" icon="mail" :onClick="sendEmail" v-if="isButton_(scrId, 'SD') && detailForm.sndStCd !== 'SND_CMPL'">
						{{ getButtonMsg_(scrId, 'SD') }}
					</sf-button> -->
					<!-- 초기화 -->
					<!-- <sf-button
						line
						size="sm"
						icon="error"
						:onClick="setInitForm"
						v-if="isButton_(scrId, 'IN') && (!detailForm.pgsStCd || detailForm.pgsStCd == 10)"
					>
						{{ getButtonMsg_(scrId, 'IN') }}
					</sf-button> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as Yup from 'yup';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/ptin/PowTourStts/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		saveAction(pgsStCd) {
			const rollbackCode = this.detailForm.pgsStCd;
			let confirmMsg = '';
			try {
				if (!this.user.email) {
					throw new Error(this.getMessage_('QWCC001791')); //사용자 관리 페이지에서 이메일 정보를 먼저 등록해주세요.
				}
				if (!this.detailForm.powLnCd || !this.detailForm.insnDd || !this.detailForm.ipnNos) {
					//[ 검사일자, 라인, 차수 ]이/가 없습니다. 팝업을 닫고 다시 진행해주세요.
					const errmsg = this.$sf_formatString(this.getMessage_('QWCC001919'), [
						`${this.getMessage_('QWCC001032')}, ${this.getMessage_('QWCC001137')},  ${this.getMessage_('QWCC001379')}`
					]);
					throw new Error(errmsg);
				}
				if (pgsStCd == '0') {
					//임시 저장
					confirmMsg = 'QWCC001787';
					this.setDetailForm_({ key: 'sndStCd', value: 'TMP_STG' });
				} else {
					if (pgsStCd == '10') {
						// 검토반려 일 때 검토 비고 필수
						confirmMsg = 'QWCC001788';
						if (!this.detailForm.rmk) {
							throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001527')]));
						}
						// 오류로 이메일이 저장되지 않은 상태로 진행되었을 경우, 반려하기 위해서 작성자의 이메일을 넣어준다.
						if (!this.detailForm.rcptNm || !this.detailForm.rcptAdr) {
							// 글쓴이를 수신처로
							this.detailForm.rcptNm = this.detailForm.dsprNm;
							this.detailForm.rcptAdr = this.detailForm.dsprAdr;
							// 현 작성사를 발신자로
							this.detailForm.dsprNm = this.user.userName;
							this.detailForm.dsprAdr = this.user.email;
						}
					} else if (pgsStCd == '20') {
						// 작성
						confirmMsg = 'QWCC001794';
						this.schemaReg.validateSync(this.detailForm);
						this.extraValidate();
					} else if (pgsStCd == '30') {
						//회신
						confirmMsg = 'QWCC001793';
						this.schemaReply.validateSync(this.detailForm);
					} else if (pgsStCd == '40') {
						//검토
						confirmMsg = 'QWCC001785';
					}
					this.setDetailForm_({ key: 'sndStCd', value: 'NSND' }); //미발송
				}
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_(confirmMsg),
					buttons: [{ title: 'Ok', clickFn: () => this.middleAction(pgsStCd, rollbackCode) }]
				});
			} catch (error) {
				this.setDetailForm_({ key: 'pgsStCd', value: rollbackCode });
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		middleAction(pgsStCd, rollbackCode) {
			this.setDetailForm_({ key: 'pgsStCd', value: pgsStCd });
			// 검토반려 10 작성 20 회신 30 검토 40
			if (pgsStCd !== '40') {
				this.save(rollbackCode);
			} else {
				// 검토의 경우, 파일 첨부할 것이 없기 때문에 전송 양식이 달라져 분기처리함.
				this.update(rollbackCode);
			}
		},
		/**저장 로직 */
		async save(rollbackCode) {
			try {
				this.$sf_toggleLoading(true);
				const {
					header: { code, messageCd },
					body
				} = await this.saveData_(this.detailFormData_);
				const value = { insnDd: body.insnDd, powLnCd: body.powLnCd, powBttmInfmNo: body.powBttmInfmNo };
				this.setState_({ key: 'popupSearchParams', value: Object.assign({}, this.popupSearchParams, value) });
				this.commonAfterSave(code, messageCd, rollbackCode);
			} catch (error) {
				this.setDetailForm_({ key: 'pgsStCd', value: rollbackCode });
				this.$sf_toast({ type: 'error', message: error.message || this.getMessage_('QWCC001402') });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		/** 업데이트 로직 (10 반려, 40 검토만 해당) */
		async update(rollbackCode) {
			try {
				this.$sf_toggleLoading(true);
				const {
					header: { code, messageCd }
				} = await this.updateData_(this.detailFormUpdate_);
				this.commonAfterSave(code, messageCd, rollbackCode);
			} catch (error) {
				this.setDetailForm_({ key: 'pgsStCd', value: rollbackCode });
				this.$sf_toast({ type: 'error', message: error.message || this.getMessage_('QWCC001402') });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		deleteAction() {
			try {
				const { powBttmInfmNo, affrPrcsId, pgsStCd, rgnId } = this.detailForm;
				if (!powBttmInfmNo || !affrPrcsId) {
					throw new Error(this.getMessage_('QWCC001508')); //에러 발생. 다시 시도
				}
				if (pgsStCd > 20) {
					throw new Error(this.getMessage_('QWCC001507')); //회신 이후 단계는 삭제가 불가능
				}
				if (pgsStCd == 20 && rgnId !== this.getAffrInfo_.writerId) {
					throw new Error(this.getMessage_('QWCC001509')); //작성자만 삭제가 가능합니다.
				}
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001196'),
					buttons: [{ title: 'Ok', clickFn: this.delete }]
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		async delete() {
			try {
				this.$sf_toggleLoading(true);
				const { code, messageCd } = await this.deleteData_(this.detailFormUpdate_);
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
				}
				code === 0 && this.$emit('deleteFin');
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message || this.getMessage_('QWCC001404') });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		setInitForm() {
			this.setPopupInit_();
		},
		/** 저장 후 새로고침 */
		refresh() {
			this.$emit('refresh');
		},
		/** 저장 공통 로직 ; 에러 체크 혹은 정상 저장 시 새로고침 */
		commonAfterSave(code, messageCd, rollbackCode) {
			try {
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
				}
				code === 0 && this.refresh();
				code === 3 && this.setDetailForm_({ key: 'pgsStCd', value: rollbackCode }); //실패시 다시 복구
			} catch (error) {
				this.setDetailForm_({ key: 'pgsStCd', value: rollbackCode }); //실패시 다시 복구
			}
		},
		/** yup으로 못하는 검증 */
		extraValidate() {
			const { powImg1File, powImg1FileDb, mdvRplCd, rplSbc, rplRqDd } = this.detailForm;
			if (mdvRplCd === 'RPL20' && !rplSbc) {
				// RPL20 : 회신 불필요 + 대책회신 내용 빈칸일 때
				throw new Error(this.$sf_formatString(this.getMessage_('QWCC001506'), [this.getMessage_('QWCC001487')]));
			}
			if (this.rcptInfo.size < 1) {
				// 조치처 필수
				throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001460')]));
			}
			if (mdvRplCd === 'RPL10' && !rplRqDd) {
				// RPL10 :회신 필수 + 회신 요구일 필수
				throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001437')]));
			}
			// 이미지 필수 제외요청처리
			// if (!this.isValidFile(powImg1File) && !this.isValidFile(powImg1FileDb))
			// 	throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001504') + '1']));
		},
		/**파일 유무 체크 검증 */
		isValidFile(file) {
			if (!file) return false;
			return file.size > 0 || file.fileSize > 0;
		},
		sendEmail() {
			try {
				this.schemaReg.validateSync(this.detailForm);
				this.extraValidate();
				if (this.detailForm.pgsStCd && this.detailForm.pgsStCd >= 20) {
					if (this.detailForm.sndStCd !== 'SND_CMPL') {
						this.setDetailForm_({ key: 'sndStCd', value: 'NSND' });
						this.setDetailForm_({ key: 'dsprNm', value: this.user.userName });

						if (!this.detailForm.rmk) this.setDetailForm_({ key: 'rmk', value: 'User sent the email.' });

						this.$sf_showMessage({
							type: 'confirm',
							icon: 'confirm',
							message: this.getMessage_('QWCC001513'),
							buttons: [{ title: 'Ok', clickFn: () => this.save(this.detailForm.pgsStCd) }]
						});
					}
				} else {
					throw new Error(this.getMessage_('QWCC001526'));
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		showDeleteBtn() {
			return this.isPqyStaff && this.detailForm.pgsStCd < 30 && this.detailForm.powBttmInfmNo && this.getCheckWriterSelf_;
		},
		showSaveBtn() {
			return this.isPqyStaff && this.detailForm.pgsStCd < 20 && this.getCheckWriterSelf_;
		},
		showRegBtn() {
			return this.isPqyStaff && this.detailForm.pgsStCd < 30 && this.getCheckWriterSelf_;
		},
		showIspBtn() {
			//RPL10 : 회신 필요
			debugger
			return this.getCheckReplyAuth_ && this.detailForm.mdvRplCd == 'RPL10' && (this.detailForm.pgsStCd == 20 || this.detailForm.pgsStCd == 10);
		},
		showCsetBtn() {
			return this.isPqyReviewer && this.detailForm.pgsStCd == 30;
		},
		showRejectBtn() {
			return this.isPqyReviewer && this.detailForm.pgsStCd > 10 && this.detailForm.pgsStCd < 40;
		},
		schemaReply() {
			return Yup.object().shape({
				powPrbmCaus: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001441')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001441')])), //공정이상원인
				bttmMdvSbc: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001443')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001443')])), //개선대책
				mdvDd: Yup.date()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001444')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001444')])) //대책일자
			});
		},
		schemaReg() {
			return Yup.object().shape({
				//{0}은(는) 팔수 입력 값 입니다. ,
				mdvRplCd: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001436')])) // 대책 회신
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001436')])), // 대책 회신
				dsprNm: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001522')])) // 발신처 이름
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001522')])), // 발신처 이름
				dsprAdr: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001523')])) // 발신처 이메일
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001523')])), // 발신처 이메일
				powPrbmTitl: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001438')])) //제목
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001438')])), //제목
				powPrbmSbc: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001439')])) //공정 이상 내용
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001439')])) //공정 이상 내용
			});
		}
	}
};
</script>

<style lang="scss" scoped></style>
